import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { setHtmlLang } from './applyPageSeo';

/** Synchronise <html lang> avec i18next. */
export default function HtmlLangSync() {
  const { i18n } = useTranslation();

  useEffect(() => {
    setHtmlLang(i18n.language);
    const onChange = (lng: string) => setHtmlLang(lng);
    i18n.on('languageChanged', onChange);
    return () => {
      i18n.off('languageChanged', onChange);
    };
  }, [i18n]);

  return null;
}
